import {
  Box,
  Button,
  Flex,
  FormProvider,
  ReadOnlyField,
  TextField,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import React from 'react';
import { SectionGrid } from '../SectionGrid';
import { useUserProfile } from './hooks';

const UserProfile = () => {
  const { t } = useTranslation();
  const { formId, user, formMethods, handleSubmit, onSubmit, isLoadingMutate } =
    useUserProfile();
  return (
    <Box maxW="868px">
      <SectionGrid>
        <ReadOnlyField label={t('common.name')} value={user.firstName} />
        <ReadOnlyField label={t('common.lastName')} value={user.lastName} />
        <ReadOnlyField label={t('common.CUIT/CUIL')} value={user?.fiscalId} />
        <form id={formId} onSubmit={handleSubmit(onSubmit)} noValidate>
          <FormProvider {...formMethods}>
            <TextField
              name={'phoneNumber'}
              label={t('common.phone')}
              errorMessageFormatter={t}
            />
          </FormProvider>
        </form>
        <ReadOnlyField label={t('common.email')} value={user.email} />
      </SectionGrid>
      <Flex justify="end">
        <Button
          variant="primary"
          type="submit"
          form={formId}
          isLoading={isLoadingMutate}
          isDisabled={!formMethods.formState.isDirty}
        >
          {t('common.saveChanges')}
        </Button>
      </Flex>
    </Box>
  );
};

export default UserProfile;
